import React from 'react';
import { PulseLoading } from 'src/components/PulseUI';

interface StrategyExecutingStateProps {
  /**
   * Optional header content to display above the loading state
   * Typically used to show strategy title and description
   */
  header?: React.ReactNode;
  /**
   * Height of the loading container
   * @default 'h-32'
   */
  height?: string;
  /**
   * Additional CSS classes for the container
   */
  className?: string;
}

/**
 * Component that displays a loading state when a strategy is still executing
 * Shows PulseLoading animation with optional header content
 *
 * @example
 * // Basic usage
 * <StrategyExecutingState />
 *
 * @example
 * // With header
 * <StrategyExecutingState
 *   header={
 *     <div>
 *       <h3>Strategy Name</h3>
 *       <p>Strategy description</p>
 *     </div>
 *   }
 * />
 *
 * @example
 * // Custom height
 * <StrategyExecutingState height="h-[640px]" />
 */
const StrategyExecutingState: React.FC<StrategyExecutingStateProps> = ({
  header,
  height = 'h-32',
  className = '',
}) => {
  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {header}
      <div
        className={`relative ${height} rounded-lg border border-neutral-200 bg-slate-100`}
      >
        <PulseLoading />
      </div>
    </div>
  );
};

export default StrategyExecutingState;
